import { render, staticRenderFns } from "./RdmCalendarMonthly.vue?vue&type=template&id=2275e8d5&scoped=true&"
import script from "./RdmCalendarMonthly.vue?vue&type=script&lang=ts&"
export * from "./RdmCalendarMonthly.vue?vue&type=script&lang=ts&"
import style0 from "./RdmCalendarMonthly.vue?vue&type=style&index=0&id=2275e8d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275e8d5",
  null
  
)

export default component.exports